import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(4),
    width: '100%',
    paddingTop: theme.spacing(1),
  },
  contentHeading: {
    fontFamily: 'Poppins',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '24px',
    letterSpacing: '0.15px',
    color: theme.palette.labraText.primary,
  },
  description: {
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '20px',
    textAlign: 'left',
    color: theme.palette.labraText.description,
  },
  managedContent: {
    gap: theme.spacing(3),
    display: 'flex',
    flexDirection: 'column',
  },
  descriptionNote: {
    fontWeight: 600,
    fontSize: '14px',
  },
  noteWrapper: {
    marginTop: theme.spacing(1),
    letterSpacing: theme.spacing(0.03125),
  },
  cloudWrapper: {
    width: '290px',
    marginTop: theme.spacing(3),
  },
  productTypeSelection: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
  },
  contactSupportBanner: {
    backgroundColor: theme.palette.note.main,

    padding: theme.spacing(3),
    borderRadius: theme.spacing(0.5),
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'space-between',
    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
    flexDirection: 'column',
    gap: theme.spacing(3),
  },

  contactSupportBannerContent: {
    margin: '0',
    fontSize: theme.spacing(1.75),
    lineHeight: '20px',
    letterSpacing: theme.spacing(0.03125),
    color: theme.palette.textField.dark,
  },
  image: {
    display: 'flex',
    width: '40px',
    height: '28px',
    justifyContent: 'center',
    alignItems: 'flex-end',
    objectFit: 'contain',
  },
  errorMessage: {
    color: theme.palette.error.dark,
    fontSize: '12px',
    marginTop: theme.spacing(1),
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '16px',
  },
  productListingSelector: {
    width: '720px',
  },
  customContent: {
    paddingLeft: `${theme.spacing(5)} !important`,
    marginLeft: theme.spacing(-5),
  },
}))
